/**
 * @param {*} subject
 * @returns {Boolean}
 */
export default function isObjectId(subject) {
  if (!subject) {
    return false;
  }

  const checkForObjectIdRegExp = /^[0-9a-fA-F]{24}$/;
  const checkForUUIDRegExp = (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  );
  const matchesObjectId = subject.toLowerCase().match(checkForObjectIdRegExp);
  const matchesUUID = subject.match(checkForUUIDRegExp);

  if (matchesObjectId || matchesUUID) {
    return true;
  }

  return false;
}

/**
 * @returns {String}
 */
export function mongoObjectId() {
  // eslint-disable-next-line no-bitwise
  const timestamp = (new Date().getTime() / 1000 | 0).toString(16);

  // eslint-disable-next-line no-bitwise
  return timestamp + "xxxxxxxxxxxxxxxx".replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase();
}
